
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M15.5 11.5001C15.5 13.5001 13 15.0001 13 16.5001H11C11 15.0001 8.5 13.5001 8.5 11.5001C8.5 9.57005 10.07 8.00005 12 8.00005C13.93 8.00005 15.5 9.57005 15.5 11.5001ZM13 17.5001H11V18.0001C11 18.5501 11.45 19.0001 12 19.0001C12.55 19.0001 13 18.5501 13 18.0001V17.5001ZM22 12.0001C22 9.54005 21.11 7.29005 19.64 5.55005C19.35 5.21005 18.84 5.17005 18.52 5.49005C18.25 5.76005 18.22 6.20005 18.46 6.49005C19.73 7.97005 20.5 9.90005 20.5 12.0001C20.5 14.1001 19.73 16.0301 18.46 17.5201C18.21 17.8101 18.25 18.2501 18.52 18.5201C18.84 18.8401 19.35 18.8001 19.64 18.4601C21.11 16.7101 22 14.4601 22 12.0001ZM3.5 12.0001C3.5 9.90005 4.27 7.97005 5.54 6.48005C5.79 6.19005 5.75 5.75005 5.48 5.48005C5.17 5.17005 4.65 5.20005 4.36 5.54005C2.89 7.29005 2 9.54005 2 12.0001C2 14.4601 2.89 16.7101 4.36 18.4601C4.65 18.8001 5.16 18.8401 5.48 18.5201C5.75 18.2501 5.78 17.8101 5.54 17.5201C4.27 16.0301 3.5 14.1001 3.5 12.0001ZM17.5 12.0001C17.5 13.2801 17.06 14.4701 16.32 15.4101C16.09 15.7001 16.12 16.1201 16.39 16.3901C16.71 16.7101 17.24 16.6801 17.52 16.3201C18.44 15.1301 19 13.6301 19 12.0001C19 10.3701 18.44 8.87005 17.51 7.69005C17.23 7.33005 16.7 7.30005 16.38 7.62005C16.12 7.88005 16.08 8.30005 16.31 8.60005C17.06 9.53005 17.5 10.7201 17.5 12.0001ZM7.62 16.3801C7.88 16.1201 7.92 15.7001 7.69 15.4001C6.94 14.4701 6.5 13.2801 6.5 12.0001C6.5 10.7201 6.94 9.53005 7.68 8.59005C7.91 8.30005 7.88 7.88005 7.61 7.61005C7.3 7.30005 6.77 7.33005 6.49 7.68005C5.56 8.87005 5 10.3701 5 12.0001C5 13.6301 5.56 15.1301 6.49 16.3201C6.77 16.6701 7.3 16.7001 7.62 16.3801Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-online-prediction`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconOnlinePrediction

    ```js
    <b-new-b-icon-online-prediction />
    ```
</docs>


